import React, { useState, useEffect } from 'react';
import '../assest/WhatsAppButton.css';

const WhatsAppButton = () => {
  const [iconSize, setIconSize] = useState(60);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Ekran boyutunu kontrol eden fonksiyon
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIconSize(45); // Mobil cihazlar için küçük boyut
      } else {
        setIconSize(60); // Masaüstü için normal boyut
      }
    };

    // Sayfa yüklendiğinde ve boyut değiştiğinde çalıştır
    handleResize();
    window.addEventListener('resize', handleResize);

    // Temizleme fonksiyonu
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Widget'ı aç/kapat
  const toggleWidget = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setMessage(''); // Widget açılırken mesajı temizle
    }
  };

  // Modal dışına tıklandığında kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen) {
        const modal = document.querySelector('.whatsapp-container');
        if (modal &&
          !modal.contains(event.target)) {
          setIsOpen(false);
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // WhatsApp'a gönder
  const sendToWhatsApp = () => {
    const finalMessage = message.trim() || "Merhaba! Bilgi almak istiyorum.";
    const encodedMessage = encodeURIComponent(finalMessage);
    const whatsappUrl = `https://wa.me/905441000229?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank', 'noopener noreferrer');
    setIsOpen(false);
    setMessage('');
  };

  // Enter tuşuna basılınca gönder
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendToWhatsApp();
    }
  };

  // Mesaj yazma durumunu kontrol et
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <div className="whatsapp-container">
      {/* Chat Widget */}
      {isOpen && (
        <div className="whatsapp-chat-widget">
          <div className="chat-header">
            <div className="chat-header-info">
              <div className="agent-avatar">
                <div className="avatar-ring">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    width="32"
                    height="32"
                  />
                </div>
              </div>
              <div className="agent-details">
                <h4>BiKuyum WhatsApp</h4>
              </div>
            </div>
            <button
              className="close-chat"
              onClick={toggleWidget}
              aria-label="Sohbeti kapat"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </div>

          <div className="chat-body">
            <div className="welcome-message">
              <div className="message-bubble">
                <div className="message-content">
                  <p>Merhaba! 👋</p>
                  <p>Size nasıl yardımcı olabilirim?</p>
                </div>
                <span className="message-time">
                  {new Date().toLocaleTimeString('tr-TR', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </div>
            </div>
          </div>

          <div className="chat-input">
            <div className="input-container">
              <div className="input-wrapper">
                <textarea
                  value={message}
                  onChange={handleMessageChange}
                  onKeyPress={handleKeyPress}
                  placeholder="Mesajınızı yazın..."
                  rows="2"
                  className="message-input"
                />
              </div>
              <button
                className="send-button"
                onClick={sendToWhatsApp}
                disabled={!message.trim()}
                aria-label="Mesaj gönder"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                </svg>
              </button>
            </div>
            <div className="quick-messages">
              <button
                className="quick-msg-btn"
                onClick={() => setMessage('Ürün hakkında bilgi almak istiyorum.')}
              >
                💍 Ürün Bilgisi
              </button>
              <button
                className="quick-msg-btn"
                onClick={() => setMessage('Sipariş durumu hakkında bilgi almak istiyorum.')}
              >
                📦 Sipariş Takibi
              </button>
              <button
                className="quick-msg-btn"
                onClick={() => setMessage('Ödeme seçenekleri hakkında bilgi almak istiyorum.')}
              >
                💳 Ödeme Bilgisi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <div
        className={`whatsapp-button ${isOpen ? 'active' : ''} ${isHovered ? 'hovered' : ''}`}
        onClick={toggleWidget}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="WhatsApp sohbetini aç"
      >
        <div className="button-content">
          <div className="icon-container">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              width={iconSize}
              height={iconSize}
              className='wp-icon'
            />
          </div>
          {isHovered && !isOpen && (
            <div className="tooltip">
              <span>WhatsApp'tan mesaj gönder</span>
              <div className="tooltip-arrow"></div>
            </div>
          )}
        </div>

        {/* Pulse Animation */}
        <div className="pulse-ring"></div>
        <div className="pulse-ring delay-1"></div>
        <div className="pulse-ring delay-2"></div>
      </div>
    </div>
  );
};

export default WhatsAppButton;